<template>
  <b-card>
    <DeleteSplashScreen
      :splash-screen="toBeDeletedScreen"
      @deleted="fetch"
    />
    <SplashScreenForm
      :splash-screen="activeSplashScreen"
      @done="fetch"
    />
    <b-button
      class="mb-1"
      variant="primary"
      @click="newSplashScreen"
    >
      Add Splash Screen
    </b-button>
    <b-row>
      <b-col md="4">
        <ZonesSearch
          label="Search by zone"
          @zone-selected="$event => queryParams.zone = $event"
        />
      </b-col>
        <b-col md="4">
          <b-form-group label="Is Default" label-for="is_default_search">
            <v-select
              id="is_default_search"
              v-model="queryParams.is_default"
              label="text"
              :reduce="option => option.value"
              :options="defaultOptions"
              :clearable="false"
            />
          </b-form-group>
        </b-col>
      <b-col
        md="4"
        class="d-flex justify-content-center align-items-center"
      >
        <b-button
          variant="primary"
          @click="fetch"
        >
          Search
        </b-button>
      </b-col>
    </b-row>
    <base-overlay :show="fetching">
      <b-table
        :items="list"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="openEditModal(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="deletePopupHandler(data.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </base-overlay>
  </b-card>
</template>

<script>
import {
  BTable, BCard, BButton,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import formatDate from '@/utils/date-format'
import SplashScreenForm from '../components/SplashScreenForm.vue'
import DeleteSplashScreen from '../components/DeleteSplashScreen.vue'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'

export default {
  components: {
    DeleteSplashScreen,
    BTable,
    BCard,
    BButton,
    SplashScreenForm,
    ZonesSearch,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  setup(_, ctx) {
    const fetching = ref(false)
    const tableColumns = [
      {
        label: 'Zone',
        key: 'zone',
        formatter: val => val.split('::')[1],
      },
      {
        label: 'Status',
        key: 'status',
      },
      {
        label: 'is default',
        key: 'is_default',
        formatter: val => (val ? 'Yes' : 'No'),
      },
      {
        label: 'Start datetime',
        key: 'start_datetime',
        formatter: val => formatDate(val),
      },
      {
        label: 'End datetime',
        key: 'end_datetime',
        formatter: val => formatDate(val),
      },
      {
        label: 'Created At',
        key: 'created_at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]
    const list = ref([])

    const defaultOptions = [
      { text: 'All', value: undefined },
      { text: 'Default', value: true },
      { text: 'Not Default', value: false },
    ]

    const queryParams = ref({
      zone: '',
      is_default: undefined,
    })
    const fetch = async () => {
      fetching.value = true
      const res = await axiosIns.get('/drivers/splash-screen/filter', {
        params: queryParams.value,
      })
      const { data } = res.data
      list.value = data.items
      fetching.value = false
    }

    fetch()

    const activeSplashScreen = ref()
    const newSplashScreen = () => {
      activeSplashScreen.value = undefined
      ctx.root.$bvModal.show('splash-screen-form')
    }
    const openEditModal = item => {
      activeSplashScreen.value = item
      ctx.root.$bvModal.show('splash-screen-form')
    }

    const toBeDeletedScreen = ref(null)
    const deletePopupHandler = event => {
      toBeDeletedScreen.value = { ...event }
      ctx.root.$bvModal.show('delete-splash-screen-modal')
    }

    return {
      toBeDeletedScreen,
      deletePopupHandler,
      activeSplashScreen,
      openEditModal,
      newSplashScreen,
      fetching,
      tableColumns,
      queryParams,
      defaultOptions,
      fetch,
      list,
    }
  },
}
</script>
